(function () {
  class DurationSelector extends HTMLElement {

    connectedCallback() {
      this._scope = this.closest('[data-section-type]') || document;
      this._quantityInputSelector = this.dataset.qtyInput || '.quantity-selector__value';
      this._options = Array.prototype.slice.call(this.querySelectorAll('[data-element="duration-option"]'));
      this._labelTarget = this.querySelector('[data-element="duration-label"]');
      this._packTarget = this.querySelector('[data-element="duration-pack"]');

      if (this._options.length === 0) return;

      this._clickHandler = this._onClick.bind(this);
      this.addEventListener('click', this._clickHandler);

      var defaultQuantity = parseInt(this.dataset.defaultQuantity, 10) || 0;

      if (defaultQuantity > 1) {
        // on rejoue la sélection par défaut via les boutons +/- pour que tout le reste
        // (prix, nombre de boîtes, messages de livraison, GTM, remises) se mette à jour.
        // décalé d'une frame : dans le quick shop le markup est injecté avant que les
        // écouteurs de quantité ne soient attachés au contenu fraîchement chargé
        requestAnimationFrame(function () {
          this._applyQuantity(defaultQuantity);
          this._syncFromInput();
        }.bind(this));
      }

      this._syncFromInput();
    }

    disconnectedCallback() {
      if (this._clickHandler) this.removeEventListener('click', this._clickHandler);
    }

    _onClick(event) {
      var option = event.target.closest('[data-element="duration-option"]');

      if (!option || !this.contains(option)) return;

      event.preventDefault();

      var quantity = parseInt(option.dataset.quantity, 10);
      if (!quantity) return;

      this._applyQuantity(quantity);
      this._syncFromInput();
    }

    _getQuantityInput() {
      var input = this._scope.querySelector(this._quantityInputSelector);
      if (!input) input = document.querySelector(this._quantityInputSelector);
      return input;
    }

    /**
     * Amène le sélecteur de quantité à la valeur voulue en cliquant sur ses boutons,
     * de façon à déclencher tous les rendus déjà branchés sur ces clics.
     */
    _applyQuantity(quantity) {
      var input = this._getQuantityInput();
      if (!input) return;

      var increaseButton = this._scope.querySelector('[data-action="increase-quantity"]');
      var decreaseButton = this._scope.querySelector('[data-action="decrease-quantity"]');
      if (!increaseButton || !decreaseButton) return;

      var current = parseInt(input.value, 10) || 1;
      var steps = Math.abs(quantity - current);
      var button = quantity > current ? increaseButton : decreaseButton;

      // on relit l'input après chaque clic : on s'arrête dès que la cible est atteinte,
      // ou si un clic ne change plus rien (bouton désactivé, écouteur absent)
      for (var i = 0; i < steps; i++) {
        var before = parseInt(input.value, 10);
        button.click();
        var after = parseInt(input.value, 10);
        if (after === quantity || after === before) break;
      }
    }

    _syncFromInput() {
      var input = this._getQuantityInput();
      var quantity = input ? (parseInt(input.value, 10) || 1) : 1;
      var selectedOption = null;

      this._options.forEach(function (option) {
        var isSelected = parseInt(option.dataset.quantity, 10) === quantity;
        option.classList.toggle('is-selected', isSelected);
        option.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
        if (isSelected) selectedOption = option;
      });

      if (this._labelTarget) {
        this._labelTarget.textContent = selectedOption ? selectedOption.dataset.label : '';
      }

      if (this._packTarget) {
        this._packTarget.textContent = selectedOption ? selectedOption.dataset.pack : '';
      }
    }
  }

  if (!customElements.get('duration-selector')) {
    customElements.define('duration-selector', DurationSelector);
  }

})();
